import type { ReactElement } from "react";
import type { RepairMode, SlipMeta } from "../_stubData.ts";
import { SrIcon, fmtMoney, fmtOdds } from "./SrIcon.tsx";

interface Props {
  meta: SlipMeta;
  mode: RepairMode;
  finalOdds: number;
  finalPayout: number;
  finalProb: number;
  onDownload: () => void;
  onShare: () => void;
  onReset: () => void;
  onPlace: () => void;
  /** Start a fresh repair from scratch (clears session + returns to upload). */
  onStartNew?: () => void;
  /** Exit the repair tool entirely (e.g. back to /lab). */
  onExit?: () => void;
}

export function StickyBar({
  meta,
  mode,
  finalOdds,
  finalPayout,
  finalProb,
  onDownload,
  onShare,
  onReset,
  onPlace,
  onStartNew,
  onExit,
}: Props): ReactElement {
  return (
    <div className="sr-stickybar">
      <div className="sr-stickybar-summary">
        <div className="pair">
          <span className="k">Repaired ({mode === "sharp" ? "Sharp" : "Safer"})</span>
          <span
            className="v"
            style={{ color: mode === "sharp" ? "var(--sr-sharp)" : "var(--sr-safer)" }}
          >
            {fmtOdds(finalOdds)}×
          </span>
        </div>
        <div className="pair">
          <span className="k">Potential payout</span>
          <span className="v">
            {meta.currency}
            {fmtMoney(finalPayout)}{" "}
            <span className="ccy">
              on {meta.currency}
              {fmtMoney(meta.stake)}
            </span>
          </span>
        </div>
        <div className="pair">
          <span className="k">Win prob</span>
          <span className="v">{finalProb.toFixed(2)}%</span>
        </div>
      </div>
      <div className="sr-stickybar-actions">
        {onExit && (
          <button className="btn" onClick={onExit} title="Close the repair tool">
            <SrIcon name="x" size={12} />
            Exit
          </button>
        )}
        {onStartNew && (
          <button className="btn" onClick={onStartNew} title="Repair another slip">
            <SrIcon name="upload" size={12} />
            Start new
          </button>
        )}
        <button className="btn" onClick={onReset}>
          <SrIcon name="undo" size={12} />
          Reset changes
        </button>
        <button className="btn" onClick={onShare}>
          <SrIcon name="share" size={12} />
          Share link
        </button>
        <button className="btn" onClick={onDownload}>
          <SrIcon name="download" size={12} />
          Download PDF
        </button>
        <button className="btn primary" onClick={onPlace}>
          Place repaired slip
          <SrIcon name="arrow" size={12} />
        </button>
      </div>
    </div>
  );
}
